import React, { useState, useRef, useEffect } from 'react';
// 导入 SCSS Module 文件（命名为 styles）
import styles from './index.module.scss';
import { ChevronDown } from 'lucide-react';
import cn from 'classnames';

interface TextWithSeeMoreProps {
  text: string;
  lineLimit?: number;
  translateIcon?: React.ReactNode;
}

export const TextWithSeeMore: React.FC<TextWithSeeMoreProps> = ({ text, lineLimit = 3, translateIcon = null }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showSeeMore, setShowSeeMore] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const calcTextRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkLineCount = () => {
      if (!calcTextRef.current) return;
      const isOverflow = calcTextRef.current.scrollHeight > calcTextRef.current.clientHeight;
      setShowSeeMore(isOverflow);
    };

    checkLineCount();
    window.addEventListener('resize', checkLineCount);
    return () => window.removeEventListener('resize', checkLineCount);
  }, [text, lineLimit]);

  useEffect(() => {
    if (!textRef.current) return;
    if (isExpanded) {
      textRef.current.style.webkitLineClamp = 'none';
      textRef.current.style.maxHeight = 'none';
    } else {
      textRef.current.style.webkitLineClamp = lineLimit.toString();
      textRef.current.style.maxHeight = 'inherit';
    }
  }, [isExpanded, lineLimit]);

  const handleSeeMore = () => {
    setIsExpanded(true);
  };

  const handleSeeLess = () => {
    setIsExpanded(false);
  };

  const renderBtn = (isInline = false) => {
    return (
      <React.Fragment>
        {showSeeMore ? (
          <div
            className={cn('gap-[14px]', isInline ? styles.inlineEndWrap : styles.endWrap, {
              'ml-2': isInline,
            })}
          >
            {isExpanded ? (
              <button className={styles.seeLessBtn} onClick={handleSeeLess}>
                See Less
                <ChevronDown color="#2563EB" className=" rotate-180" size={16} />
              </button>
            ) : (
              <button className={styles.seeMoreBtn} onClick={handleSeeMore}>
                See More
                <ChevronDown color="#2563EB" size={16} />
              </button>
            )}

            {translateIcon ? (
              <React.Fragment>
                <div className="w-[1px] h-3 bg-[#A3A3A3]"></div>
                {translateIcon}
              </React.Fragment>
            ) : null}
          </div>
        ) : null}
      </React.Fragment>
    );
  };
  return (
    // 引用模块化类名：styles.textContainer
    <div className={styles.textContainer}>
      <p
        className={cn(styles.textContent, styles.calcText, 'opacity-0 absolute top-0 left-0 z-[-1]')}
        ref={calcTextRef}
      >
        {text}
      </p>
      <p
        ref={textRef}
        // 组合类名：基础类 + 展开状态类
        className={`${styles.textContent} ${isExpanded ? styles.expanded : ''}`}
        style={{
          WebkitLineClamp: isExpanded ? 'none' : lineLimit,
          maxHeight: isExpanded ? 'none' : 'inherit',
        }}
      >
        {text}
        {/* 如果不显示 See More 按钮，就显示翻译图标 */}
        {!showSeeMore ? <span className="pl-1">{translateIcon}</span> : null}

        {showSeeMore && isExpanded ? renderBtn(true) : null}
      </p>
      {showSeeMore && !isExpanded ? renderBtn() : null}
    </div>
  );
};
